import api from '@/api/index';

/**
 * @class WorkPlans
 */
class WorkPlans {
  /**
   * Get a list of all work plans for the client
   *
   * @param clientId
   * @param withActionsCount
   * @returns {AxiosPromise<any>}
   */
  static list(clientId, withActionsCount = false) {
    let url = `/work-plans?clientId=${clientId}`;

    if (withActionsCount) {
      url += '&withActionsCount=1';
    }
    return api.get(url);
  }

  /**
   * Create a work plan
   *
   * @param clientId
   * @param name
   * @param dueDate
   * @returns {AxiosPromise<any>}
   */
  static create(clientId, name, dueDate) {
    return api.post(`/work-plans?clientId=${clientId}`, {
      name,
      dueDate,
    });
  }

  /**
   * Update details on a work plan
   *
   * @param workPlanId
   * @param name
   * @param dueDate
   * @returns {AxiosPromise<any>}
   */
  static update(workPlanId, name, dueDate) {
    return api.put(`/work-plans/${workPlanId}`, {
      name,
      dueDate,
    });
  }

  /**
   * Format data to multiselect object
   *
   * @param workPlans
   * @returns {*}
   */
  static formatDataToMultiSelectObj(workPlans) {
    return workPlans.map(workPlan => ({
      label: `${workPlan.name} (${getFormatDate(workPlan.dueDate)})`,
      name: workPlan.name,
      workPlanId: workPlan.workPlanId,
      dueDate: getFormatDate(workPlan.dueDate),
    }));
  }
}

function getFormatDate(date) {
  const d = new Date(date);
  const day = (`0${d.getDate()}`).slice(-2);
  const month = (`0${d.getMonth() + 1}`).slice(-2);
  return `${day}/${month}/${d.getFullYear()}`;
}

export default WorkPlans;
